import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class GripIcon extends Component {
    render() {
        return (
            <svg {...this.props} height="4" viewBox="0 0 10 4" width="10" xmlns="http://www.w3.org/2000/svg"><path d="M0 3h10v1H0V3zm0-3h10v1H0V0z" fillRule="evenodd"/></svg>
        )
    }
}

export default withCssClassName(GripIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/grip-icon.js